module.exports = __webpack_public_path__ + "img/lumilive_3.273ac28f.png";